/*
 * MDB shim for MDBInput
 * Files currently importing this symbol from "mdbreact":
 * - src/App.jsx
 * - src/Components/Custom/InformationChangeModal.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Patient/pqQuoteSelector.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUICheckbox from "@mui/material/Checkbox";
import MUITextField from "@mui/material/TextField";
import MUIFormControlLabel from "@mui/material/FormControlLabel";

export default function MDBInput({
    type = "text",
    label,
    value,
    defaultValue,
    valueDefault,
    onChange,
    rows,
    disabled,
    checked,
    ...rest
}) {
    if (type === "checkbox") {
        return (
            <MUIFormControlLabel
                control={
             <MUICheckbox
                checked={Boolean(checked ?? value)}
                onChange={onChange}
                disabled={disabled}
                {...rest}
            />
            }
            label={label}
            />
           
        );
    }

    const multiline = type === "textarea" || Number(rows) > 1;
    const isControlled = value !== undefined && value !== null;
    const resolvedDefaultValue = defaultValue !== undefined ? defaultValue : valueDefault;

    return (
        <MUITextField
            type={multiline ? undefined : type}
            label={label}
            onChange={onChange}
            multiline={multiline}
            rows={rows}
            disabled={disabled}
            {...(isControlled ? { value } : { defaultValue: resolvedDefaultValue })}
            {...rest}
        />
    );
}
